import { get } from 'lodash';
import { QUESTION, TRO_PAGE_RECORDING } from './timeTrackingKeys';

export const getTimeTrackingDuration = (state, timerKey, isPrecise = false) => {
    const { start, stop } = get(state, timerKey, {});
    const timeDifferenceSeconds = (stop - start) / 1000;
    return isPrecise ? timeDifferenceSeconds : Math.max(1, Math.floor(timeDifferenceSeconds));
};

export const getQuestionTimeTrackingDuration = state => getTimeTrackingDuration(state, QUESTION);

export const getCommonQuestionTimeStart = state => get(state, `${QUESTION}.start`, {});

export const getReadingDuration = state => state.readingDuration;

export const getBookRecordingDurationMs = state => {
    const { totalRecordingDuration = null } = get(state, TRO_PAGE_RECORDING, {});
    return totalRecordingDuration;
};
